module.exports = "/_next/static/images/zw-80632a3cfdf4986bcae6696cc83235d7.svg";